module.exports = __webpack_public_path__ + "static/media/portrait10.e4d39a6b.jpg";